import axios from 'axios';
import Auth0 from '../../../../../../../store/actions/auth/Auth';
import handleError from '../../../../../../../components/FormHelpers/handleError';
import { actionCreators as documentsActionCreators } from '../data/Documents/actions';
import { getStoredFile, clearFileStore } from '../../../../../../../components/FileUpload/FileUpload';

const { postFile, uploadComplete } = documentsActionCreators;

const submitForm = async (values, dispatch, setError, deliveryId) => {
  let req1 = {};
  const client = Auth0.getClientInfo();
  const basedOn = deliveryId;

  const arrayToPost = {
    userFullName: client.given_name + ' ' + client.family_name,
    userEmail: client.email,
    ...basedOn && { basedOn },
    ...values
  };
  delete arrayToPost['fileDrop'];

  try {
    req1 = await axios.post(`/api/admin/deliveries/toCustomer`, {
      ...arrayToPost
    }, {
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
    });
  } catch (err) {
    handleError(err.response, setError);
    throw err;
  }

  // Retrieve actual File objects from the fileStore using metadata
  const promises = values.fileDrop.map(fileMeta => {
    const file = getStoredFile(fileMeta.fileId);
    if (!file) {
      console.error(`File not found in store: ${fileMeta.fileName}`);
      return Promise.reject(new Error(`File not found: ${fileMeta.fileName}`));
    }
    return dispatch(postFile(file, req1.data.deliveryId));
  });

  return Promise.all(promises)
    .then(() => {
      clearFileStore();
      return dispatch(uploadComplete(req1.data.deliveryId));
    })
    .catch(err => {
      handleError(err.response, setError);
      throw err;
    });
};

export default submitForm;
